var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.12444 16.2633C1.78371 16.0691 1.5003 15.7883 1.30286 15.4494C1.10542 15.1106 1.00095 14.7255 1 14.3333V3.22222C1 2 2 1 3.22222 1H14.3333C15.1667 1 15.62 1.42778 16 2.11111M5.44444 8.40778C5.44444 7.62185 5.75665 6.86812 6.31238 6.31238C6.86812 5.75665 7.62185 5.44444 8.40778 5.44444H18.0367C18.4258 5.44444 18.8112 5.52109 19.1707 5.67002C19.5302 5.81894 19.8569 6.03721 20.1321 6.31238C20.4072 6.58756 20.6255 6.91423 20.7744 7.27376C20.9234 7.63329 21 8.01863 21 8.40778V18.0367C21 18.4258 20.9234 18.8112 20.7744 19.1707C20.6255 19.5302 20.4072 19.8569 20.1321 20.1321C19.8569 20.4072 19.5302 20.6255 19.1707 20.7744C18.8112 20.9234 18.4258 21 18.0367 21H8.40778C8.01863 21 7.63329 20.9234 7.27376 20.7744C6.91423 20.6255 6.58756 20.4072 6.31238 20.1321C6.03721 19.8569 5.81894 19.5302 5.67002 19.1707C5.52109 18.8112 5.44444 18.4258 5.44444 18.0367V8.40778Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.07ea239424a8ff2f0746aae34c2b4019.svg";
export { ForwardRef as ReactComponent };